import { CONST } from "@constants/CONST";
import { COMPANY } from "@constants/company-data";
import { BUSINESS_USER } from "@constants/user-data";
import { PREFERENCE } from "@constants/preference-data";

/**
 * 설계 상수
 */
export const DesignData = {
  //----------------------------------
  // 공통
  //----------------------------------
  //----------------------------------
  // 화면 변수
  //----------------------------------
  // 부분 견적
  SECTION_ESTIMATE: "부분 견적",
  // 담당자 없음
  ESTIMATOR_NONE: "없음",
  // 견적 정보 없음
  ESTIMATE_NONE: "견적 정보가 없습니다.",
  //----------------------------------
  // 데이터 변수
  //----------------------------------
  designMode: {
    DESIGN: "design",
    TEMPLATE: "template",
  },
  estimateMode: {
    ESTIMATE: "estimate",
    ESTIMATE_REVIEW: "estimateReview",
  },
  progressStatus: {
    DESIGNING_ESTIMATING: "설계/견적중",
    CONTRACT_COMPLETED: "계약완료",
    BUILDING: "시공중",
    COMPLETED: "시공완료",
    STOPPED: "중단",
  },

  //----------------------------------
  // 구조 레이블, 아이디, 인덱스
  //----------------------------------

  LB_STRUCT_SINGLE: "단동",
  LB_STRUCT_DOUBLE_WIDTH: "광폭",
  LB_STRUCT_RAIN_PROOF: "비가림",
  LB_STRUCT_INTERLOCK: "연동",
  LB_STRUCT_ANGULAR_IL: "각연동",
  LB_STRUCT_VENLO: "벤로",
  LB_STRUCT_OTHER: "기타",

  ID_STRUCT_SINGLE: "sg",
  ID_STRUCT_DOUBLE_WIDTH: "dw",
  ID_STRUCT_RAIN_PROOF: "rp",
  ID_STRUCT_INTERLOCK: "il",
  ID_STRUCT_ANGULAR_IL: "ai",
  ID_STRUCT_VENLO: "vl",
  ID_STRUCT_OTHER: "ot",
} as const;

export const DesignModifyData: any = {
  progressStatus: {
    label: "진행상태",
    desc: "",
    items: [
      {
        text: "설계/견적중",
        value: CONST.LB_PROGRESS_STATUS_DESIGNING_ESTIMATING,
      },
      {
        text: "계약완료",
        value: CONST.LB_PROGRESS_STATUS_CONTRACT_COMPLETED,
      },
      {
        text: "시공중",
        value: CONST.LB_PROGRESS_STATUS_BUILDING,
      },
      {
        text: "시공완료",
        value: CONST.LB_PROGRESS_STATUS_COMPLETED,
      },
      {
        text: "중단",
        value: CONST.LB_PROGRESS_STATUS_STOPPED,
      },
    ],
  },
  buildingSelected: {
    label: "시공 여부",
    desc: "",
    items: [
      {
        text: "예",
        value: true,
      },
      {
        text: "아니오",
        value: false,
      },
    ],
  },
  vehicleEntrySelected: {
    label: "차량진입 여부",
    desc: "",
    items: [
      {
        text: "예",
        value: "예",
      },
      {
        text: "아니오",
        value: "아니오",
      },
      {
        text: "알 수 없음",
        value: "알 수 없음",
      },
    ],
  },
  electricAvailableSelected: {
    label: "전기가용 여부",
    desc: "",
    items: [
      {
        text: "예",
        value: "예",
      },
      {
        text: "아니오",
        value: "아니오",
      },
      {
        text: "알 수 없음",
        value: "알 수 없음",
      },
    ],
  },
  groundFlatSelected: {
    label: "지반평탄 여부",
    desc: "",
    items: [
      {
        text: "예",
        value: "예",
      },
      {
        text: "아니오",
        value: "아니오",
      },
      {
        text: "알 수 없음",
        value: "알 수 없음",
      },
    ],
  },
  basicSubsidySelected: {
    label: "정부사업 여부",
    desc: "",
    items: [
      {
        text: "예",
        value: true,
      },
      {
        text: "아니오",
        value: false,
      },
    ],
  },
};

export const BASICLEVEL: BasicLevel = {
  _index: 0,
  _width: 0,
  _length: 0,
  _heightShoulder: 0,
  _depthLaying: 0,
  _distanceShoulderPad: 0,
  _perimeterRoof: 0,
  _perimeterRoofIdeal: 0,
  _heightRoofMax: 0,
  _heightRoofMaxIdeal: 0,
  _heightMax: 0,
  _heightMaxIdeal: 0,
  _lengthRafterIdeal: 0,
};

export const BASIC: Basic = {
  basicLevelAC: [
    {
      _index: 0,
      _width: 0,
      _length: 0,
      _heightShoulder: 0,
      _depthLaying: 0,
      _distanceShoulderPad: 0,
      _perimeterRoof: 0,
      _perimeterRoofIdeal: 0,
      _heightRoofMax: 0,
      _heightRoofMaxIdeal: 0,
      _heightMax: 0,
      _heightMaxIdeal: 0,
      _lengthRafterIdeal: 0,
    },
  ],
  _structureName: null,
  _buildingNumber: 0,
  _levelNumber: 0,
  _buildingInterval: 0,
  _levelInterval: 0,
  _area: 0,
  _pyeong: 0,
  _wingLeft: 0,
  _wingRight: 0,
  _wingFront: 0,
  _wingBack: 0,
  _isVariableLength: false,
  _bendingExpenseFlag: false,
  _padVinylFlag: false,
  _buildingSelected: false,
  _subsidySelected: false,
};

export const ESTIMATE: Estimate = {
  id: null,
  estimateStatus: null,
  upperMemo1: null,
  totalMaterialCostSupplyPurchase: 0,
  totalMaterialCostVatPurchase: 0,
  totalMaterialCostPricePurchase: 0,
  totalMaterialCostSupplyUnit: 0,
  totalMaterialCostVatUnit: 0,
  totalMaterialCostPriceUnit: 0,
  totalMaterialCostSupplyRated: 0,
  totalMaterialCostVatRated: 0,
  totalMaterialCostPriceRated: 0,
  totalMaterialCostSupply: 0,
  totalMaterialCostVat: 0,
  totalMaterialCostPrice: 0,
  totalExpenseSupplyPurchase: 0,
  totalExpenseVatPurchase: 0,
  totalExpensePricePurchase: 0,
  totalExpenseSupplyUnit: 0,
  totalExpenseVatUnit: 0,
  totalExpensePriceUnit: 0,
  totalExpenseSupplyRated: 0,
  totalExpenseVatRated: 0,
  totalExpensePriceRated: 0,
  totalExpenseSupply: 0,
  totalExpenseVat: 0,
  totalExpensePrice: 0,
  totalLaborCostSupplyPurchase: 0,
  totalLaborCostVatPurchase: 0,
  totalLaborCostPricePurchase: 0,
  totalLaborCostSupplyUnit: 0,
  totalLaborCostVatUnit: 0,
  totalLaborCostPriceUnit: 0,
  totalLaborCostSupplyRated: 0,
  totalLaborCostVatRated: 0,
  totalLaborCostPriceRated: 0,
  totalLaborCostSupply: 0,
  totalLaborCostVat: 0,
  totalLaborCostPrice: 0,
  totalMaterialSupplyPurchase: 0,
  totalMaterialVatPurchase: 0,
  totalMaterialPricePurchase: 0,
  totalMaterialSupplyUnit: 0,
  totalMaterialVatUnit: 0,
  totalMaterialPriceUnit: 0,
  totalMaterialSupplyRated: 0,
  totalMaterialVatRated: 0,
  totalMaterialPriceRated: 0,
  totalMaterialSupply: 0,
  totalMaterialVat: 0,
  totalMaterialPrice: 0,
  totalBuildingSupplyPurchase: 0,
  totalBuildingVatPurchase: 0,
  totalBuildingPricePurchase: 0,
  totalBuildingSupplyUnit: 0,
  totalBuildingVatUnit: 0,
  totalBuildingPriceUnit: 0,
  totalBuildingSupplyRated: 0,
  totalBuildingVatRated: 0,
  totalBuildingPriceRated: 0,
  totalBuildingSupply: 0,
  totalBuildingVat: 0,
  totalBuildingPrice: 0,
  totalSupplyPurchase: 0,
  totalVatPurchase: 0,
  totalPricePurchase: 0,
  totalSupplyUnit: 0,
  totalVatUnit: 0,
  totalPriceUnit: 0,
  totalSupplyRated: 0,
  totalVatRated: 0,
  totalPriceRated: 0,
  totalSupply: 0,
  totalVat: 0,
  totalPrice: 0,
  rateFinal: 1,
  rateUnit: 1,
  rateDiscount: 0,
  lastUpdate: null,
};

export const DESIGN: Design = {
  id: null,
  // analysis: Analysis,
  // review: Review,
  contractEnabled: false,
  isSaveForContract: false,
  saveEnabled: false,
  editEnabled: false,
  currentLevelIndex: null,
  // itemModel: ,
  preference: PREFERENCE,
  basic: {
    basicLevelAC: [
      {
        _index: null,
        _width: null,
        _length: null,
        _heightShoulder: null,
        _depthLaying: null,
        _distanceShoulderPad: null,
        _perimeterRoof: null,
        _perimeterRoofIdeal: null,
        _heightRoofMax: null,
        _heightRoofMaxIdeal: null,
        _heightMax: null,
        _heightMaxIdeal: null,
        _lengthRafterIdeal: null,
      },
    ],
    _structureName: null,
    _buildingNumber: null,
    _levelNumber: null,
    _buildingInterval: null,
    _levelInterval: null,
    _area: null,
    _pyeong: null,
    _wingLeft: null,
    _wingRight: null,
    _wingFront: null,
    _wingBack: null,
    _isVariableLength: false,
    _bendingExpenseFlag: false,
    _padVinylFlag: false,
    _buildingSelected: false,
    _subsidySelected: false,
  },
  subsidyService: {
    serviceName: null,
    expense: null,
    institute: null,
    managerName: null,
    managerPhone: null,
    note: null,
  },
  // struct: Struct,
  estimate: ESTIMATE,
  company: COMPANY,
  estimator: BUSINESS_USER,
  customer: {
    customerType: null,
    name: null,
    mobileNumber: null,
  },
  designCode: null,
  title: null,
  usageAndCrop: null,
  note: null,
  templateName: null,
  templateExplain: null,
  templateImg: null,
  progressStatus: null,
  designStatus: null,
  isDeleted: false,
  isTemplate: false,
  isDefault: false,
  isSectionEstimate: false,
  markType: null,
  markDate: null,
  openDate: null,
  buildingAddress: {
    postcode: null,
    road: null,
    jibeon: null,
    detail: null,
  },
  buildingPeriod: {
    startDate: null,
    endDate: null,
  },
  vehicleEntry: null,
  electricAvailable: null,
  groundFlat: null,
  creator: null,
  designUpdater: null,
  lastUpdater: null,
  lastUpdate: null,
  dbVersion: null,
  createDate: null,
  dbUpdate: null,
};
